module.exports = __webpack_public_path__ + "static/img/bg13.af5e27d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg13.png
// module id = Nzh7
// module chunks = 1